import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { type FormikProps } from 'formik';
import dayjs from 'dayjs';
import { type CommenceOfStudyFormProps } from './types';
import { COMMENCE_OF_STUDY } from '../lang';
import { DatePicker } from '../../../../../../components';

// this component is (almost) the same as ExtendPaymentDeadlineBox, but do not abstract them now
// abstract them when the third similar component comes up

type CommenceOfStudyBoxProps = {
  formik: FormikProps<CommenceOfStudyFormProps>;
};

export const CommenceOfStudyBox: React.FC<CommenceOfStudyBoxProps> = (
  props: CommenceOfStudyBoxProps,
) => {
  const { formik } = props;
  return (
    <>
      <Stack direction={'row'} justifyContent={'space-between'} spacing={8}>
        <Box className="w-full">
          <Typography>
            {COMMENCE_OF_STUDY.DIALOG.CONFIRM_DATE.COMPONENT.REPORTED_DATE}
          </Typography>
          <DatePicker
            className="w-full"
            name="confirmDate"
            value={formik.values.confirmDate}
            minDate={dayjs().add(-1, 'year')}
            maxDate={dayjs()}
            onChange={date => {
              void formik.setFieldValue('confirmDate', date);
            }}
            onBlur={formik.handleBlur}
            error={
              (formik.touched.confirmDate as boolean) &&
              Boolean(formik.errors.confirmDate)
            }
            helperText={
              (formik.touched.confirmDate as boolean) && (
                <>{formik.errors.confirmDate}</>
              )
            }
          />
        </Box>
      </Stack>
    </>
  );
};
